import { render, staticRenderFns } from "./TestC.vue?vue&type=template&id=2de6e70d&scoped=true&"
import script from "./TestC.vue?vue&type=script&lang=ts&"
export * from "./TestC.vue?vue&type=script&lang=ts&"
import style0 from "./TestC.vue?vue&type=style&index=0&id=2de6e70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de6e70d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
